import type { UseMutationOptions } from "@tanstack/react-query";
import { useMutation } from "@tanstack/react-query";
import type { AppendPatientConsentResponse } from "@/APIRequests/patientTyped";
import { patientRequestsTyped } from "@/APIRequests/patientTyped";
import type { PatientConsent, PolicyConsentPayloadDTO } from "@/core/types";
import { useDispatch } from "react-redux";
import { getPatientProfile } from "@/redux/actions/auth";

type Context = {
  previousConsents: PatientConsent[];
  updatedConsent: PatientConsent;
};

type UseAppendConsentMutationOptions = UseMutationOptions<
  AppendPatientConsentResponse,
  unknown,
  PolicyConsentPayloadDTO,
  Context
>;

/** We want to explicitly opt-out from the default loading spinner to show skeletons and do optimistic updates */
const params = {
  showLoader: false,
};

export function useAppendConsentMutation(options?: UseAppendConsentMutationOptions) {
  const dispatch = useDispatch();

  return useMutation({
    mutationFn: (data) => patientRequestsTyped.append_patient_consent({ data, params }),
    onSuccess: () => {
      /** Refetch profile to redraw the updated view
       * This is a temporary solution until we move profile data to tanstack query
       */
      dispatch(getPatientProfile(true));
    },
    ...options,
  });
}
